import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../lib/utils";

const bannerVariants = cva("p-4 rounded-md flex gap-2 ", {
  variants: {
    variant: {
      default: "bg-muted text-muted-foreground",
      info: "bg-info text-support ",
    },
    size: {
      default: "text-b3 ",
      sm: "text-b4 ",
    },
    width: {
      default: "w-fit ",
      full: "w-full ",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
    width: "default",
  },
});

export interface BannerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof bannerVariants> {}

function Banner({ className, variant, size, width, ...props }: BannerProps) {
  return (
    <div
      className={cn(bannerVariants({ variant, size, width }), className)}
      {...props}
    />
  );
}

export { Banner, bannerVariants };
